import { run } from './src/cli';

run();
